import { features } from '@/mocks/features';

export default function FeatureCards() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3 bg-accent-100 px-3 py-1 rounded-full">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Why Users Choose Our Sugargoo Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Everything you need for smarter international shopping — all in one place
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-7 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-200 group-hover:text-primary-600 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}